import i18next from 'i18next';
import cloneDeep from 'lodash.clonedeep';
import type { EnhancedProperty } from '../../@types/item';

export const HINTS = () =>
  Object.freeze<{ [key: string]: string }>({
    abs: i18next.t('hint.abs', { ns: 'vehicleProperties' }),
    acceleration: i18next.t('hint.acceleration', { ns: 'vehicleProperties' }),
    adultOccupantNCAP: i18next.t('hint.adultOccupantNCAP', { ns: 'vehicleProperties' }),
    aeb: i18next.t('hint.aeb', { ns: 'vehicleProperties' }),
    airbagCutOffSwitch: i18next.t('hint.airbagCutOffSwitch', { ns: 'vehicleProperties' }),
    airbagDriver: i18next.t('hint.airbagDriver', { ns: 'vehicleProperties' }),
    airbagFrontal: '',
    airbagFrontalHead: '',
    airbagKnees: '',
    airbagPassenger: i18next.t('hint.airbagPassenger', { ns: 'vehicleProperties' }),
    airbagSideChest: '',
    airbagSidePelvis: '',
    alcolock: i18next.t('hint.alcolock', { ns: 'vehicleProperties' }),
    androidAuto: i18next.t('hint.androidAuto', { ns: 'vehicleProperties' }),
    annualBonus: i18next.t('hint.annualBonus', { ns: 'vehicleProperties' }),
    annualMalus: i18next.t('hint.annualMalus', { ns: 'vehicleProperties' }),
    annualTax: i18next.t('hint.annualTax', { ns: 'vehicleProperties' }),
    antiTheftAlarm: i18next.t('hint.antiTheftAlarm', { ns: 'vehicleProperties' }),
    appConnect: i18next.t('hint.appConnect', { ns: 'vehicleProperties' }),
    appleCarPlay: i18next.t('hint.appleCarPlay', { ns: 'vehicleProperties' }),
    aux: i18next.t('hint.aux', { ns: 'vehicleProperties' }),
    auxiliaryLamps: '',
    batteryCapacity: i18next.t('hint.batteryCapacity', { ns: 'vehicleProperties' }),
    batteryWarrantyDistance: '',
    batteryWarrantyTime: '',
    blindSpotWarner: i18next.t('hint.blindSpotWarner', { ns: 'vehicleProperties' }),
    bluetooth: i18next.t('hint.bluetooth', { ns: 'vehicleProperties' }),
    bluetoothAudio: i18next.t('hint.bluetoothAudio', { ns: 'vehicleProperties' }),
    bluetoothPhone: i18next.t('hint.bluetoothPhone', { ns: 'vehicleProperties' }),
    brakeAssistance: i18next.t('hint.brakeAssistance', { ns: 'vehicleProperties' }),
    carDamageWarrantyDistance: '',
    carDamageWarrantyTime: '',
    centerDisplay: i18next.t('hint.centerDisplay', { ns: 'vehicleProperties' }),
    centralLocking: i18next.t('hint.centralLocking', { ns: 'vehicleProperties' }),
    chargeTimeNormal: i18next.t('hint.chargeTimeNormal', { ns: 'vehicleProperties' }),
    chargeTimeQuick: i18next.t('hint.chargeTimeQuick', { ns: 'vehicleProperties' }),
    chassis: i18next.t('hint.chassis', { ns: 'vehicleProperties' }),
    childOccupantNCAP: i18next.t('hint.childOccupantNCAP', { ns: 'vehicleProperties' }),
    childSafetyLocks: i18next.t('hint.childSafetyLocks', { ns: 'vehicleProperties' }),
    childSeatBeltPassenger: i18next.t('hint.childSeatBeltPassenger', { ns: 'vehicleProperties' }),
    childSeatBeltRear: i18next.t('hint.childSeatBeltRear', { ns: 'vehicleProperties' }),
    co2: i18next.t('hint.co2', { ns: 'vehicleProperties' }),
    colorName: '',
    combinedEmissionsWLTP: i18next.t('hint.combinedEmissionsWLTP', { ns: 'vehicleProperties' }),
    cruiseControl: i18next.t('hint.cruiseControl', { ns: 'vehicleProperties' }),
    curtainAirbags: '',
    displacementCC: i18next.t('hint.displacementCC', { ns: 'vehicleProperties' }),
    displacementLitres: i18next.t('hint.displacementLitres', { ns: 'vehicleProperties' }),
    driverAlertnessDetection: i18next.t('hint.driverAlertnessDetection', {
      ns: 'vehicleProperties',
    }),
    drivingWheel: i18next.t('hint.drivingWheel', { ns: 'vehicleProperties' }),
    electricalEngine: '',
    electricalRange: i18next.t('hint.electricalRange', { ns: 'vehicleProperties' }),
    electricalRangeEPA: i18next.t('hint.electricalRangeEPA', { ns: 'vehicleProperties' }),
    electricalRangeNEDC: i18next.t('hint.electricalRangeNEDC', { ns: 'vehicleProperties' }),
    electricalRangeWLTP: i18next.t('hint.electricalRangeWLTP', { ns: 'vehicleProperties' }),
    electricalSeatDriver: i18next.t('hint.electricalSeatDriver', { ns: 'vehicleProperties' }),
    electricalSeatPassenger: i18next.t('hint.electricalSeatPassenger', { ns: 'vehicleProperties' }),
    emergencyCalling: i18next.t('hint.emergencyCalling', { ns: 'vehicleProperties' }),
    engineConfiguration: i18next.t('hint.engineConfiguration', { ns: 'vehicleProperties' }),
    engineCylinders: i18next.t('hint.engineCylinders', { ns: 'vehicleProperties' }),
    engineName: '',
    engineVolume: '',
    enrichmentProviderEquipPackages: '',
    enrichmentProviderExteriorPackages: '',
    enrichmentProviderInteriorPackages: '',
    enrichmentProviderTrimPackages: '',
    environmentClass: i18next.t('hint.environmentClass', { ns: 'vehicleProperties' }),
    finish: '',
    fuelConsumptionMixedDrivingNEDC: i18next.t('hint.fuelConsumptionMixedDrivingNEDC', {
      ns: 'vehicleProperties',
    }),
    fuelConsumptionMixedDrivingWLTP: i18next.t('hint.fuelConsumptionMixedDrivingWLTP', {
      ns: 'vehicleProperties',
    }),
    fuelConsumptionCityDriving: i18next.t('hint.fuelConsumptionCityDriving', {
      ns: 'vehicleProperties',
    }),
    fuelConsumptionCountryRoadDriving: i18next.t('hint.fuelConsumptionCountryRoadDriving', {
      ns: 'vehicleProperties',
    }),
    fuelConsumptionMixedDriving: i18next.t('hint.fuelConsumptionMixedDriving', {
      ns: 'vehicleProperties',
    }),
    fuelTypes: i18next.t('hint.fuelType', { ns: 'vehicleProperties' }),
    gearboxName: '',
    gestureControls: i18next.t('hint.gestureControls', { ns: 'vehicleProperties' }),
    gps: i18next.t('hint.gps', { ns: 'vehicleProperties' }),
    grossWeight: i18next.t('hint.grossWeight', { ns: 'vehicleProperties' }),
    groundClearence: i18next.t('hint.groundClearence', { ns: 'vehicleProperties' }),
    hasAutomaticGearbox: '',
    hdmi: i18next.t('hint.hdmi', { ns: 'vehicleProperties' }),
    headRoomFront: i18next.t('hint.headRoomFront', { ns: 'vehicleProperties' }),
    headRoomRear: i18next.t('hint.headRoomRear', { ns: 'vehicleProperties' }),
    headUpDisplay: i18next.t('hint.headUpDisplay', { ns: 'vehicleProperties' }),
    heatedSteeringWheel: '',
    height: i18next.t('hint.height', { ns: 'vehicleProperties' }),
    hybridComponentsWarrantyDistance: '',
    hybridComponentsWarrantyTime: '',
    interiorMaterial: i18next.t('hint.interiorMaterial', { ns: 'vehicleProperties' }),
    isofixRearSeat: i18next.t('hint.isofixRearSeat', { ns: 'vehicleProperties' }),
    keylessEntry: i18next.t('hint.keylessEntry', { ns: 'vehicleProperties' }),
    keylessStart: i18next.t('hint.keylessStart', { ns: 'vehicleProperties' }),
    laneAssistance: i18next.t('hint.laneAssistance', { ns: 'vehicleProperties' }),
    legRoomFront: i18next.t('hint.legRoomFront', { ns: 'vehicleProperties' }),
    legRoomRear: i18next.t('hint.legRoomRear', { ns: 'vehicleProperties' }),
    length: i18next.t('hint.length', { ns: 'vehicleProperties' }),
    lowBeam: '',
    mainBeam: '',
    mainBeamAssistance: i18next.t('hint.mainBeamAssistance', { ns: 'vehicleProperties' }),
    manufactureYear: i18next.t('hint.manufactureYear', { ns: 'vehicleProperties' }),
    massage: i18next.t('hint.massage', { ns: 'vehicleProperties' }),
    maxLoadWeight: '',
    maxRoofWeight: i18next.t('hint.maxRoofWeight', { ns: 'vehicleProperties' }),
    maxSpeed: i18next.t('hint.maxSpeed', { ns: 'vehicleProperties' }),
    maxTrailerLoadBraked8Percent: '',
    maxTrailerLoadUnbraked: i18next.t('hint.maxTrailerLoadUnbraked', { ns: 'vehicleProperties' }),
    mildHybrid: i18next.t('hint.mildHybrid', { ns: 'vehicleProperties' }),
    mileage: i18next.t('hint.mileage', { ns: 'vehicleProperties' }),
    modelName: i18next.t('hint.modelName', { ns: 'vehicleProperties' }),
    modelYear: i18next.t('hint.modelYear', { ns: 'vehicleProperties' }),
    ncapStar: i18next.t('hint.ncapStar', { ns: 'vehicleProperties' }),
    ncapYear: i18next.t('hint.ncapYear', { ns: 'vehicleProperties' }),
    newVehicleWarrantyDistance: '',
    newVehicleWarrantyTime: '',
    noiseReducingWindows: i18next.t('hint.noiseReducingWindows', { ns: 'vehicleProperties' }),
    numberOfGears: i18next.t('hint.numberOfGears', { ns: 'vehicleProperties' }),
    numberOfSpeakers: i18next.t('hint.numberOfSpeakers', { ns: 'vehicleProperties' }),
    numberOfUSBPorts: '',
    otherAirbags: '',
    parkingAssistance: i18next.t('hint.parkingAssistance', { ns: 'vehicleProperties' }),
    parkingSensorsFront: i18next.t('hint.parkingSensorsFront', { ns: 'vehicleProperties' }),
    parkingSensorsRear: i18next.t('hint.parkingSensorsRear', { ns: 'vehicleProperties' }),
    pedestrianNCAP: i18next.t('hint.pedestrianNCAP', { ns: 'vehicleProperties' }),
    preHeater: i18next.t('hint.preHeater', { ns: 'vehicleProperties' }),
    rainSensors: i18next.t('hint.rainSensors', { ns: 'vehicleProperties' }),
    remoteStart: i18next.t('hint.remoteStart', { ns: 'vehicleProperties' }),
    rimSize: i18next.t('hint.rimSize', { ns: 'vehicleProperties' }),
    roofColor: i18next.t('hint.roofColor', { ns: 'vehicleProperties' }),
    roofRailing: i18next.t('hint.roofRailing', { ns: 'vehicleProperties' }),
    safetyAssistNCAP: i18next.t('hint.safetyAssistNCAP', { ns: 'vehicleProperties' }),
    seats: i18next.t('hint.seats', { ns: 'vehicleProperties' }),
    segment: i18next.t('hint.segment', { ns: 'vehicleProperties' }),
    serviceWeight: i18next.t('hint.serviceWeight', { ns: 'vehicleProperties' }),
    shoulderRoomFront: i18next.t('hint.shoulderRoomFront', { ns: 'vehicleProperties' }),
    shoulderRoomRear: i18next.t('hint.shoulderRoomRear', { ns: 'vehicleProperties' }),
    sideMirrorFolding: i18next.t('hint.sideMirrorFolding', { ns: 'vehicleProperties' }),
    speakerBrand: '',
    startAndStop: i18next.t('hint.startAndStop', { ns: 'vehicleProperties' }),
    steeringWheelMaterial: '',
    sunRoof: '',
    tankVolume: i18next.t('hint.tankVolume', { ns: 'vehicleProperties' }),
    timingBeltServiceIntervalDistance: i18next.t('hint.timingBeltServiceIntervalDistance', {
      ns: 'vehicleProperties',
    }),
    timingBeltServiceIntervalTime: i18next.t('hint.timingBeltServiceIntervalTime', {
      ns: 'vehicleProperties',
    }),
    tintedWindows: i18next.t('hint.tintedWindows', { ns: 'vehicleProperties' }),
    tiresFront: i18next.t('hint.tiresFront', { ns: 'vehicleProperties' }),
    tiresRear: i18next.t('hint.tiresRear', { ns: 'vehicleProperties' }),
    torque: i18next.t('hint.torque', { ns: 'vehicleProperties' }),
    touchScreen: i18next.t('hint.touchScreen', { ns: 'vehicleProperties' }),
    towHitch: '',
    towHitchDetachable: '',
    towHitchFoldable: '',
    trafficSignRecognition: i18next.t('hint.trafficSignRecognition', { ns: 'vehicleProperties' }),
    trailerTotalWeight: i18next.t('hint.trailerTotalWeight', { ns: 'vehicleProperties' }),
    transmissionKnobMaterial: '',
    trcSystem: i18next.t('hint.trcSystem', { ns: 'vehicleProperties' }),
    tripComputer: i18next.t('hint.tripComputer', { ns: 'vehicleProperties' }),
    trunkDepth: '',
    trunkHeight: '',
    trunkOutlet: '',
    trunkSpace: i18next.t('hint.trunkSpace', { ns: 'vehicleProperties' }),
    trunkSpaceFront: '',
    trunkWidth: '',
    typeOfElectricCar: i18next.t('hint.typeOfElectricCar', { ns: 'vehicleProperties' }),
    upholstery: '',
    usb: i18next.t('hint.usb', { ns: 'vehicleProperties' }),
    ventilatedSeats: i18next.t('hint.ventilatedSeats', { ns: 'vehicleProperties' }),
    wheelBase: i18next.t('hint.wheelBase', { ns: 'vehicleProperties' }),
    wiFi: i18next.t('hint.wiFi', { ns: 'vehicleProperties' }),
    width: i18next.t('hint.width', { ns: 'vehicleProperties' }),
    windowLifts: '',
    wirelessPhoneCharger: i18next.t('hint.wirelessPhoneCharger', { ns: 'vehicleProperties' }),
  });

const enrichWithHint = (properties: { [key: string]: EnhancedProperty }) => {
  const clone = cloneDeep(properties);

  const hints = HINTS();

  const keys = Object.keys(clone);
  keys.forEach((key) => {
    if (hints[key]) {
      clone[key].hint = hints[key];
    }
  });

  return clone;
};

export default enrichWithHint;
